import {gameSettings} from "../utils/localforageInstance";
import {ApiService, bgSound, events, gameData, modal} from "../utils/pixiApp";
import {SoundModalComponent} from "../components/modals/SoundModalComponent";

class GameServiceClass {

    constructor() {
        this.gameState = {
            startGame: false,
            recover: false,
            startDataCompleted: false,
            gameOver: false,
            speedUp: false,
            sound: false,
            gameIsLoad: false,
            tokenIsLoad: false,
            userBalance: 0,
            bets: new Map(),
            tilesBet: [],
            outputBet: [],
            activeBet: undefined,
            prize: 0,
            finishAnimate: false,
            finishedEnd: false,
            wasStarted: false,
        };

        events.onLoadApp(() => {
            this.setGameData('gameIsLoad', true)
            gameSettings.getItem('sound').then(item => {
                if(item !== null) {
                    this.setGameData('sound', item)
                    events.emitSoundEvent(item)
                    if(item) {
                        bgSound.play()
                    } else {
                        bgSound.stop()
                    }
                } else {
                    modal.onEmitIsOpenEvent(true, new SoundModalComponent)
                }
            })
            document.addEventListener('visibilitychange',(e, a) => {
                if(document.visibilityState === 'visible' && this.gameState.sound) {
                    bgSound.play();
                } else if (this.gameState.sound) {
                    bgSound.pause()
                }
            });
        })
        events.onSoundEvent(this.onSoundEvent.bind(this))
        events.onLoadToken(this.onLoadToken.bind(this))
        events.onBetChange(this.onBetChange.bind(this))
    }

    getGameData(key = undefined) {
        if(key) {
            return this.gameState[key]
        }
        return this.gameState
    }

    setGameData(key, value) {
        this.gameState[key] = value;

        if(key === 'startGame') {
            if(value) {
                ApiService.setStartGame(this.gameState.activeBet).then((data) => {
                    const { balance, bonusBalance, prize, holdBalance } = data.playerBalance;
                    const userBalance = (balance + bonusBalance + prize + holdBalance).toFixed(2)
                    gameData.setGameData('finishAnimate', false)
                    this.setGameDataByEvent('userBalance', userBalance)
                    this.setGameData('outputBet', data.output)
                    this.setGameData('finishedEnd', false)
                    this.setGameData('prize', data.playPrize)
                    this.setGameData('activeBet', data.betAmount)
                    this.setGameData('recover', false)
                    this.setGameData('tilesBet', this.gameState.bets.get(data.betAmount))
                    this.setGameDataByEvent('startGame',  true)
                })
            }
        }
    }

    setGameDataByEvent(key, value, callback = true) {
        this.gameState[key] = value;
        events.emitGameDataChange([key]);
        if(key === 'gameOver' && value) {
            if(!this.gameState.recover && !this.getGameData('finishedEnd')) {
                this.onGameOver(callback)
            } else {
                this.setGameData('recover', false)
            }
        }
        if(key === 'finishAnimate') {
            gameData.setGameData('speedUp', false)
        }
    }

    onSoundEvent(isActive) {
        this.setGameData('sound', isActive)
        gameSettings.setItem('sound', isActive)
    }

    async onLoadToken() {
        await this.setGameData('tokenIsLoad', true)
        ApiService.getGameLobby().then(async r => {
            const { balance, bonusBalance, prize } = r.playerBalance;
            const userBalance = (balance + bonusBalance + prize).toFixed(2)
            const bets = new Map();
            r.bets.sort((a,b) => a.amount - b.amount).forEach(item => {
                item.coeffs.shift();
                bets.set(item.amount, item.coeffs)
            })
            this.setGameData('userBalance', userBalance)
            if(r.started) {
                ApiService.recover().then((data) => {
                    this.setGameData('activeBet', data.betAmount)
                    this.setGameData('prize', data.playPrize)
                    this.setGameData('tilesBet', bets.get(data.betAmount))
                    this.setGameData('outputBet', data.output)
                    this.setGameDataByEvent('recover',  true)
                })
            } else {
                this.setGameData('activeBet', r.defaultBetAmount)
                this.setGameData('tilesBet', bets.get(r.defaultBetAmount))
            }
            this.setGameData('bets', bets)
            events.emitGameDataChange(['userBalance', 'activeBet', 'bets'])
        })
    }

    onBetChange(number) {
        this.setGameData('activeBet', number)
        events.emitGameDataChange(['activeBet'])
    }

    onGameOver(callback) {
        const setFinished = () => {
            this.setGameData('finishedEnd', true)
        }
        if(callback) {
            ApiService.finish().then((data) => {
                const { balance, bonusBalance, prize } = data.playerBalance;
                const userBalance = balance + bonusBalance + prize
                setFinished()
            })
        }
    }
}

export const GameService = GameServiceClass;